const NftQuantity = ({
  value = 0,
  maxQuantity,
  selected,
  onChange,
}: {
  selected: boolean;
  value: number | undefined;
  maxQuantity: number;
  onChange: (v: number) => void;
}) => {
  return (
    <>
      <span
        className={`absolute top-1 left-1 ${
          selected ? 'bg-pink-500 text-gray-50' : 'bg-gray-50 text-gray-800'
        } rounded-lg text-xs p-1`}
      >
        {`×${maxQuantity}`}
      </span>
      {selected && maxQuantity > 1 && (
        <div className="absolute z-1 bottom-1 left-1 right-1 rounded-lg bg-gray-100 text-sm flex items-center p-1 border border-gray-300">
          <button
            type="button"
            className="flex items-center justify-center rounded-full w-5 h-5 bg-gray-50 border border-gray-300 text-gray-800 cursor-pointer hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={(e) => {
              e.stopPropagation();
              onChange(value - 1);
            }}
            disabled={maxQuantity <= 1}
          >
            {'-'}
          </button>
          <input
            type="number"
            className="flex-1 min-w-0 text-center font-medium bg-transparent text-sm p-1 border-none focus:border-pink-500 focus:ring-0 focus:outlne-0 text-gray-500"
            value={value?.toString() || '0'}
            step={1}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              e.stopPropagation();
              onChange(Number(e.currentTarget.value));
            }}
          />
          <button
            type="button"
            className="flex items-center justify-center rounded-full w-5 h-5 bg-gray-50 border border-gray-300 text-gray-800 cursor-pointer hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={(e) => {
              e.stopPropagation();
              onChange(value + 1);
            }}
            disabled={value >= maxQuantity}
          >
            {'+'}
          </button>
        </div>
      )}
    </>
  );
};

export default NftQuantity;
